<template>
    <div class="v-tagging form-control">
        <div class="v-tagging-inner" @click.self="$refs.input.focus()">
            <div v-for="(item, index) of value" :key="index" class="v-tagging-tag">
                {{ item }}
                <icon name="close" @click.prevent="removeItem(index)"/>
            </div>
            <input class="v-tagging-input"
                   v-model.trim="input"
                   ref="input"
                   @focus="showPopover"
                   @keyup.stop.up="updateSearchOffset(-1)"
                   @keyup.stop.down="updateSearchOffset(1)"
                   @keyup.stop.enter="handleInput"
                   @keyup.exact="updateSearchOffset(0)"
                   @keypress="handleKeypress"
            />
            <popover ref="popover" @toggle="handlePopoverToggle">
                <div v-for="(option, index) of computedOptions"
                     :key="index"
                     class="v-tagging-option"
                     v-c:highlighted="searchOffset === index"
                     @mouseover="searchOffset = index"
                     @click="handleInput"
                >
                    {{ option }}
                </div>
                <div class="no-result" v-if="computedOptions.length === 0 && !hasNewOption">
                    {{ __('ui/no_result') }}
                </div>
            </popover>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: Array,
            options: {default: null},
            disallowNew: {type: Boolean, default: false},
            maxLength: {type: Number, default: 0},
        },

        data() {
            return {
                input: '',
                searchOffset: 0,
            };
        },

        computed: {
            hasOptions() {
                return this.options !== null;
            },

            hasNewOption() {
                let input = this.input;
                if (this.hasOptions && this.options.includes(input)) {
                    return false;
                }
                return input !== '' && !this.disallowNew;
            },

            computedOptions() {
                let input = this.input;
                let results = [];

                if (this.hasNewOption) {
                    results.push(this.__('ui/vtagging_create', input));
                }

                return (this.options||[]).reduce((result, option) => {
                    if (!this.value.includes(option) && (input === '' || option.includes(input))) {
                        result.push(option);
                    }
                    return result;
                }, results);
            },
        },

        methods: {
            removeItem(index) {
                let value = this.value.slice(0);
                value.splice(index, 1);
                this.$emit('input', value);
                this.$refs.input.focus();
            },

            showPopover() {
                if (this.input !== '' || this.options !== null) {
                    this.$refs.popover.open();
                }
            },

            updateSearchOffset(change) {
                if (change === 0) {
                    this.searchOffset = 0;
                } else if (change > 0) {
                    if (this.searchOffset < (this.computedOptions.length-1)) {
                        this.searchOffset++;
                    }
                } else {
                    if (this.searchOffset > 0) {
                        this.searchOffset--;
                    }
                }
            },

            async handleInput() {
                let options = this.computedOptions;
                let value = this.value.slice(0);
                let input = this.input;
                let newItem = null;

                if (this.searchOffset === 0 && this.hasNewOption) {
                    newItem = input;
                } else if (options.length > 0) {
                    newItem = options[this.searchOffset];
                }

                if (newItem !== null && !value.includes(newItem) && (this.input.length <= this.maxLength || this.maxLength === 0)) {
                    value.push(newItem);
                    this.$emit('input', value);
                }

                this.input = '';
                await this.$nextTick();
                this.$refs.popover.close();
            },

            handlePopoverToggle(open) {
                if (!open) {
                    this.input = '';
                }
            },

            handleKeypress(event) {
                if (this.input.length >= this.maxLength && this.maxLength > 0) {
                    event.preventDefault();
                }
            },
        },

        watch: {
            input() {
                this.showPopover();
            },
        },
    };
</script>